import {IHttpService, IPromise} from "angular";
import {StudyUnit} from "./study-unit-selector.component";

export class StudyUnitService {
    /* @ngInject */
    constructor(private $http: IHttpService) {
    }

    public search(query: string, activeOnly: boolean = false): IPromise<StudyUnit[]> {
        return this.$http.get(`/api/study-units/units/${query}?activeOnly=${activeOnly}`).then((resp) => {
            return resp.data as any[];
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/study-unit/study-unit.service.ts